// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  row: {
    cursor: 'pointer',
    userSelect: 'none',
    // Transparent at rest so the selected border never shifts the layout.
    borderLeft: '2px solid transparent',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  // Selected = the dashboard's blue tint + left border (D50); distinct from
  // the grey hover wash so a hover never reads as a click.
  rowSelected: {
    backgroundColor: 'rgba(1, 161, 221, 0.12)',
    borderLeft: '2px solid #01A1DD',
    '&:hover': {
      backgroundColor: 'rgba(1, 161, 221, 0.12)',
    },
  },
  rowHovered: {
    backgroundColor: theme.palette.action.hover,
  },
});

export default styles;
